import React from 'react';
import {getMessage} from '../utils/messages';
import {getBreadcrumbWithoutLeaf} from '../utils/taskUtils';
import type {TaskOption} from '../types/types';
import {formatDuration} from "@/shared/utils/datefunctions";

export type TaskTotalsPanelProps = {
	totalDurations: {
		sorted: { task: TaskOption; duration: number }[];
		overall: number;
	};
};

export const TaskTotalsPanel: React.FC<TaskTotalsPanelProps> = ({totalDurations}) => (
	<div className="panel panel-default">
		<div className="panel-heading" style={{height: 65, verticalAlign: 'middle'}}>
			<h5 className="panel-title">{getMessage('monthlyRecording.totals.title')}</h5>
		</div>
		<table className="table table-condensed">
			<tbody>
			{totalDurations.sorted.map(item => (
				<tr key={item.task.id}>
					<td>
						<div>{item.task.name}</div>
						{item.task.breadCrumbs && (
							<div className="text-muted small">
								{getBreadcrumbWithoutLeaf(item.task)}
							</div>
						)}
					</td>
					<td className="text-right">{formatDuration(item.duration)}</td>
				</tr>
			))}
			{totalDurations.sorted.length === 0 && (
				<tr>
					<td colSpan={2} className="text-muted small">{getMessage('monthlyRecording.totals.empty')}</td>
				</tr>
			)}
			</tbody>
		</table>
		<hr style={{borderTop: '2px solid var(--table-border-color)', marginTop: 10, marginBottom: 10}}/>
		<div className="text-right pr-20">
			<h5>{`${getMessage('report.total')}:`} {totalDurations.overall ? formatDuration(totalDurations.overall) : '00:00'}</h5>
		</div>
	</div>
);
